module.exports = __webpack_public_path__ + "img/req_list_600.1b95d2a7.png";